module.exports = __webpack_public_path__ + "static/media/pc.57d52046.png";